import { render, staticRenderFns } from "./DeliveryModal.vue?vue&type=template&id=5a65429d&scoped=true&"
import script from "./DeliveryModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryModal.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryModal.vue?vue&type=style&index=0&id=5a65429d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a65429d",
  null
  
)

export default component.exports